// import firebaseAxios from '@/shared/firebase/firebase-axios';

export default {
  /* eslint-disable */
  fetch(lastmodified) {
    // eslint-disable-next-line 
    
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/users/history`, {
    //       params: { lastmodified }
    //     })
    //     .then((response) => response.data)
    // );
  }
};



// WEBPACK FOOTER //
// ./src/user/user-history/user-history-full/user-history-full-service.js